import { render, staticRenderFns } from "./ConfiguracionAvpt.vue?vue&type=template&id=4d49836f&scoped=true"
import script from "./ConfiguracionAvpt.vue?vue&type=script&lang=js"
export * from "./ConfiguracionAvpt.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionAvpt.vue?vue&type=style&index=0&id=4d49836f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d49836f",
  null
  
)

export default component.exports